<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    岗厦北站<br>
站点介绍<br>
岗厦北站位于深圳市福田区深南大道与彩田路交叉口的东侧，深南大道北侧绿化带中，车站大致呈东西走向布置，周边有酒店、商场、剧院、学校、政府机关等，同时临近岗厦城中村，流动人口多，人流量较大。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:11	23:51	2号线	2分35秒	5分45秒<br>
莲塘	06:10	23:49	2号线	2分35秒	5分45秒<br>
岗厦北	--	--	14号线	4分30秒	6分15秒<br>
沙田	06:00	23:30	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:15	23:50	2号线	4分钟	5分钟<br>
莲塘	06:10	23:49	2号线	4分钟	5分钟<br>
岗厦北	--	--	14号线	5分25秒	6分15秒<br>
沙田	06:00	23:30	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:15	00:40	2号线	4分钟	5分钟<br>
莲塘	06:10	00:49	2号线	4分钟	5分钟<br>
岗厦北	-	－	14号线	5分钟	6分15秒<br>
沙田	06:00	00:30	14号线	5分钟	6分15秒<br><br>
<br>
站点出口信息<br><br>
B出入口:<br>
深南大道北侧、深圳市第一职业技术学校、国际创新中心、中国邮政储蓄银行、福田区行政服务大厅<br><br>
D出入口:<br>
深南大道北侧、彩田路、宏嘉酒店、中广核大厦、深圳边防支队、平安国际酒店、华润万佳、凤凰大厦<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 岗厦北地铁站 ①（北侧）<br>
113、320、326、M133、M363、M414、M435、M447、M448、M190、N04、204、223、K204、101、高专038、高专119、高快25<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shisihaoxian",
          title: "14号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>